import React from 'react';
import { useAuthenticationService } from 'src/application/externalDependencies';
import { activityMapURL } from 'src/web-ui/pages';

export function AuthRedirect({ type }: { type: 'signup' | 'login' }) {
  const { login } = useAuthenticationService();
  React.useEffect(
    () => login({ type, returnTo: activityMapURL }),
    [type, login]
  );
  return <></>;
}
